import React, { useEffect, useState } from 'react';
import main from '../../assets/images/main.png';
import s from './Main.module.scss';
import Hero from './Hero/Hero';
import Recommend from './Recommend';
import TopAndRecommend from './TopRecommendedTours/TopAndRecommend';
import Popular from './Popular';
import Sale from './Sale';
import InstagramEmbed from "../../components/InstagramEmbed/InstagramEmbed";
import Reasons from './Reasons';
import Review from './ReviewsSection/ReviewSection';
import CategoryList from './CategoryList/CategoryList';
import Loading from '../../components/Loading/Loading';
import LocationList from './LocationList/LocationList';
import { Helmet } from 'react-helmet-async';
import ToursByCategory from "../Tours/ToursByCategory";
import ReviewCarousel from "./ReviewsSection/ReviewCarousel";
import CampaignSection from "./Campains/CampaignSection";

const Main = () => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const [customSection, setCustomSection] = useState([]);
  const [recommendedTours, setRecommendedTours] = useState([]);
  const [saleTours, setSaleTours] = useState([]);
  const [topRatedTours, setTopRatedTours] = useState([]);
  const [latestReviews, setLatestReviews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchTours = async () => {
      setLoading(true);
      try {
        const response = await fetch(`${apiUrl}/api/tours`);

        if (!response.ok) {
          throw new Error('ネットワークエラー');
        }

        const data = await response.json();
        setRecommendedTours(data.recommendedTours);
        setTopRatedTours(data.topRatedTours);
        setLatestReviews(data.latestReviews);
        setSaleTours(data.saleTours);
        setCustomSection(data.customSections);
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchTours();
  }, []);

  if (loading) {
    return (
      <div className={s.container}>
        <Loading loading={loading} />
      </div>
    );
  }

  const structuredData = [
    {
      "@context": "https://schema.org",
      "@type": "TouristAttraction",
      "name": "グレートバリアリーフ",
      "description": "シルバースイフトで行くアウターリーフツアー。揺れの少ない機構で快適に楽しめます。",
      "image": "https://yourwebsite.com/images/greatbarrierreef.jpg",
      "offers": {
        "@type": "Offer",
        "price": "302",
        "priceCurrency": "AUD",
        "availability": "https://schema.org/InStock",
        "url": "https://yourwebsite.com/tours/greatbarrierreef"
      }
    },
    {
      "@context": "https://schema.org",
      "@type": "TouristAttraction",
      "name": "ジェイさんオリジナルツアー",
      "description": "ガイドなしフリープランのキュランダツアー。スカイレールとキュランダ鉄道を楽しめます。",
      "image": "https://yourwebsite.com/images/kuranda.jpg",
      "offers": {
        "@type": "Offer",
        "price": "15000",
        "priceCurrency": "JPY",
        "availability": "https://schema.org/InStock",
        "url": "https://yourwebsite.com/tours/kuranda"
      }
    },
    {
      "@context": "https://schema.org",
      "@type": "TouristAttraction",
      "name": "ハートリーズ動物園ツアー",
      "description": "到着日におすすめ！送迎と入園券付きでお気に入りの動物に会えるツアー。",
      "image": "https://yourwebsite.com/images/heartleys.jpg",
      "offers": {
        "@type": "Offer",
        "price": "12000",
        "priceCurrency": "JPY",
        "availability": "https://schema.org/InStock",
        "url": "https://yourwebsite.com/tours/heartleys"
      }
    },
    {
      "@context": "https://schema.org",
      "@type": "TouristAttraction",
      "name": "グリーン島ツアー",
      "description": "熱気球で早朝の大自然の美しさを堪能し、グリーン島1日観光ツアー。",
      "image": "https://yourwebsite.com/images/greenisland.jpg",
      "offers": {
        "@type": "Offer",
        "price": "25000",
        "priceCurrency": "JPY",
        "availability": "https://schema.org/InStock",
        "url": "https://yourwebsite.com/tours/greenisland"
      }
    }
  ];

  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <>
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
        <title>ケアンズの旅行やツアーを最安値で予約【ジェイさんツアー】</title>
        <meta property="og:title" content="TOPページ – ケアンズの旅行やツアーを最安値で予約【ジェイさんツアー】" />
        <meta property="og:image" content={`${process.env.REACT_APP_URL}/og-image.png`} />
        <meta property="og:url" content={process.env.REACT_APP_URL} />
        <meta name="description" content="自社ツアーやオプショナルツアーも予約できます！" />
        <meta property="og:description" content="自社ツアーやオプショナルツアーも予約できます！" />
        <meta property="og:type" content="article" />
      </Helmet>
      {/* <main className={s.root}>
        <img src={main} alt="main_image" />
      </main> */}
       <Hero/>
      <LocationList />
      <TopAndRecommend customSections={customSection}  />
      <ToursByCategory />
      <ReviewCarousel  reviews={latestReviews || []} />
      <InstagramEmbed />
      <CampaignSection />
      {/*<Recommend tours={recommendedTours} />*/}
      {/*<div className={s.banner}>*/}
      {/*  <figure class="wpb_wrapper vc_figure">*/}
      {/*    <a href="/campaign/【2025限定！】ケアンズツアー学生割引" target="_blank" class="vc_single_image-wrapper   vc_box_border_grey"><img fetchpriority="high" decoding="async" width="748" height="175" src="https://dev.mightyaussie.com/wp-content/uploads/2025/01/学生限定キャンペーン実施中　トップページバナー-1024x240.png" class="vc_single_image-img attachment-large" alt="" title="学生限定キャンペーン実施中　トップページバナー" srcset="https://dev.mightyaussie.com/wp-content/uploads/2025/01/学生限定キャンペーン実施中　トップページバナー-1024x240.png 1024w, https://dev.mightyaussie.com/wp-content/uploads/2025/01/学生限定キャンペーン実施中　トップページバナー-300x70.png 300w, https://dev.mightyaussie.com/wp-content/uploads/2025/01/学生限定キャンペーン実施中　トップページバナー-768x180.png 768w, https://dev.mightyaussie.com/wp-content/uploads/2025/01/学生限定キャンペーン実施中　トップページバナー-600x141.png 600w, https://dev.mightyaussie.com/wp-content/uploads/2025/01/学生限定キャンペーン実施中　トップページバナー.png 1280w" sizes="(max-width: 748px) 100vw, 748px" /></a>*/}
      {/*  </figure>*/}
      {/*</div>*/}
      {/* <Divider /> */}
      {/*<Popular tours={topRatedTours}/>*/}
      {/*<Sale tours={saleTours} />*/}
      <Reasons />


    </>
  );
};

export default Main;
